import { memo } from 'react';
import FloorsFilter from '../../FilterRealty/FloorsFilter';
import PriceFilter from '../../FilterRealty/PriceFilter';
import SearchFilter from '../../FilterRealty/SearchFilter';
import SelectFilter from '../../FilterRealty/SelectFilter';
import { getSelectPropsCreator } from '../utils';

const EmployeesFilterForm = memo(props => {
  const {
    filter,
    filterData,
    handleFilter,
    setFilterAndExclude
  } = props;

  const createSelectProps = getSelectPropsCreator(props);
  if (!filterData) return
  return (
    <div className="sf__filter form">
      <SearchFilter
        placeholder="ФИО сотрудника, телефон"
        handleChange={v => handleFilter('query', v)}
        value={filter.query ?? ""}
        wrapperClass="sf__filter-item"
      />
      <SelectFilter
        {...createSelectProps("department")}
        data={{ title: "Отдел", identity: "department" }}
        wrapperClass="sf__filter-item"

      />
      <SelectFilter
        {...createSelectProps("access")}
        data={{ title: "Уровень доступа", identity: "access" }}
        wrapperClass="sf__filter-item"
        valueKey="value"
      />
      <SelectFilter
        {...createSelectProps("status")}
        data={{ title: "Статус", identity: "status" }}
        wrapperClass="sf__filter-item"
      />
    </div>
  );
});

export default EmployeesFilterForm;